const defaultPoints = [];

export default defaultPoints;
